import React from "react";
import { connect } from "react-redux";
import "./UserAvatar.css";

function UserAvatar(props) {
  let className;

  switch (props.type) {
    case "navbar":
      className = "navbar-avatar";
      break;
    case "home":
      className = "home-avatar";
      break;
    default:
      className = "teacher-info-avatar2";
  }

  return (
    <div className={"user-avatar-box " + className}>
      <div className="avatar-wrapper">
        <img
          src={
            (props.isViewAsCollege ? props.icon_inst : props.icon_teacher) ||
            "../../assets/img/avatar.png"
          }
          className="user-avatar-img"
          alt="user's avatar"
        />
      </div>
      {props.children}
    </div>
  );
}

function mapStateToProps(state) {
  return {
    icon_teacher: state.user ? state.user.user.img_url : "",
    icon_inst: state.college.user ? state.college.user.photo : "",
  };
}

export default connect(mapStateToProps)(UserAvatar);
